import React from "react";
import PaymentButton, { PaymentButtonProps } from "./PaymentButton";
import PaymentPolicyLinks, {
  PaymentPolicyHelpPanelContext,
} from "./PaymentPolicyLinks";
import { PaymentFooterWrapper } from "./PaymentButton.styles";

type PaymentFooterProps = PaymentButtonProps & {
  helpPanelContext?: PaymentPolicyHelpPanelContext;
};

const PaymentFooter: React.FC<PaymentFooterProps> = React.memo(
  ({ helpPanelContext, ...buttonProps }) => (
    <PaymentFooterWrapper>
      <PaymentButton {...buttonProps} />
      <PaymentPolicyLinks helpPanelContext={helpPanelContext} />
    </PaymentFooterWrapper>
  ),
);

export default PaymentFooter;
